<template>
    <section
        class="header"
        :class="alignHorizontal"
    >
        <div
            class="header__inner"
            :class="content.style.background.turnOff.value ? '' : 'header__inner--background container container--only-desktop'"
        >
            <div class="header__content">
                <zoe-atom-text
                    v-if="stringIsNotEmpty(content.text.value)"
                    class="header__text"
                    :item="content.text.value"
                />

                <div v-if="content.horizontalAlign.value">
                    <zoe-atom-media
                        v-if="deviceType === 'desktop'"
                        class="header__media"
                        :item="content.media.desktop.value"
                    />

                    <zoe-atom-media
                        v-if="deviceType === 'mobile'"
                        class="header__media"
                        :item="content.media.mobile.value"
                    />
                </div>
            </div>

            <div
                class="header__container"
                :class="showBorder"
            >
                <div
                    v-if="!content.horizontalAlign.value && (mediaIsNotEmpty(content.media.mobile.value) || mediaIsNotEmpty(content.media.desktop.value))"
                    class="header__wrapper"
                >
                    <zoe-atom-media
                        v-if="deviceType === 'desktop'"
                        class="header__media"
                        :item="content.media.desktop.value"
                    />

                    <zoe-atom-media
                        v-if="deviceType === 'mobile'"
                        class="header__media"
                        :item="content.media.mobile.value"
                    />

                    <zoe-atom-text
                        v-if="stringIsNotEmpty(content.label.value)"
                        class="header__label"
                        :item="content.label.value"
                        @click="scrollToSelector('.step__flow', -60);"
                    />
                </div>

                <zoe-organism-usps
                    v-if="content.usps.show.value"
                    :content="content.usps"
                />
            </div>
        </div>
    </section>
</template>

<script>
import ZoeAtomMedia from '@atoms/media/v1.0.0/zoe-atom-media.vue';
import ZoeAtomText from '@atoms/text/v1.0.0/zoe-atom-text.vue';
// json5-ignore
import ZoeOrganismUsps from '@organisms/usps/variation-1/v1.0.0/zoe-organism-usps.vue';
import Component from '../../../../../../resources/mixins/component/component.vue';

export default {
    components: {
        ZoeAtomText,
        ZoeAtomMedia,
        ZoeOrganismUsps,
    },

    mixins: [Component],

    computed: {
        deviceType() {
            return this.$store.state.page.deviceType;
        },

        alignHorizontal() {
            return this.content.horizontalAlign.value ? 'header--horizontal' : '';
        },

        showBorder() {
            return this.content.style.border.turnOff.value ? '' : 'header__container--border';
        },
    },
};
</script>

<style lang="scss" scoped>
@use 'step-header';

.header {
    --background: v-bind('content.style.background.color.value');
    --border-color: v-bind('content.style.border.color.value');
    --label-background: v-bind('content.style.labelBackground.value');
}
</style>
